module.exports = __webpack_public_path__ + "img/icon_3.89c4efc7.png";